import { NotebookPen, LineChart, Stethoscope } from "lucide-react";

const benefits = [
  {
    Icon: NotebookPen,
    title: "Suivi simple et rapide",
    desc: "Quelques tapotements, et c'est noté. Échelle de Bristol, douleurs, ballonnements, repas… sans culpabilité.",
    testid: "benefit-card-tracking",
  },
  {
    Icon: LineChart,
    title: "Visualise tes tendances",
    desc: "Repère ce qui déclenche une mauvaise journée. Aliments, stress, cycle — les patterns se révèlent, semaine après semaine.",
    testid: "benefit-card-trends",
  },
  {
    Icon: Stethoscope,
    title: "Partage avec ton médecin",
    desc: "Partage avec ton médecin, ton naturopathe, ou garde-le pour toi\n\nExporte un rapport clair en PDF si tu en as besoin. Fini le « euh, je crois que c'était mardi ? ».",
    testid: "benefit-card-share",
  },
];

export default function Benefits() {
  return (
    <section
      data-testid="benefits-section"
      className="relative py-20 sm:py-28 fp-grain"
      style={{ background: "var(--fp-powder)" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 relative z-10">
        <div className="max-w-2xl">
          <span
            className="text-xs uppercase font-bold tracking-[0.22em]"
            style={{ color: "var(--fp-espresso)", opacity: 0.7 }}
          >
            Pourquoi Floppy Poopy
          </span>
          <h2
            className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.08]"
            style={{ color: "var(--fp-espresso)" }}
          >
            Une app qui comprend{" "}
            <span className="italic">vraiment</span> ton quotidien.
          </h2>
          <p
            className="mt-5 text-base sm:text-lg"
            style={{ color: "var(--fp-ink-soft)", lineHeight: 1.65 }}
          >
            Parce que ton corps mérite mieux qu'une feuille Excel et des
            suppositions. On s'occupe du reste.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map(({ Icon, title, desc, testid }, i) => (
            <article
              key={title}
              data-testid={testid}
              className="group rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1"
              style={{
                background: "var(--fp-cream)",
                border: "1px solid rgba(255,255,255,0.6)",
                boxShadow: "0 20px 40px -25px rgba(111, 70, 46, 0.35)",
              }}
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-[-6deg]"
                style={{
                  background:
                    "linear-gradient(135deg, var(--fp-rose-gold), var(--fp-terracotta))",
                  color: "var(--fp-cream)",
                }}
              >
                <Icon size={26} strokeWidth={2.2} />
              </div>
              <h3
                className="font-display text-xl font-semibold mt-5"
                style={{ color: "var(--fp-espresso)" }}
              >
                {title}
              </h3>
              <p
                className="mt-2 text-sm"
                style={{ color: "var(--fp-ink-soft)", lineHeight: 1.6, whiteSpace: "pre-line" }}
              >
                {desc}
              </p>
              <div
                className="mt-5 text-xs font-semibold uppercase tracking-[0.18em]"
                style={{ color: "var(--fp-cognac)", opacity: 0.7 }}
              >
                0{i + 1}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
